import { render, staticRenderFns } from "./LimitsReachedModal.vue?vue&type=template&id=09a339c2&scoped=true"
import script from "./LimitsReachedModal.vue?vue&type=script&lang=js"
export * from "./LimitsReachedModal.vue?vue&type=script&lang=js"
import style0 from "./LimitsReachedModal.vue?vue&type=style&index=0&id=09a339c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a339c2",
  null
  
)

export default component.exports